import React from 'react';

import Table from 'components/clarity-ui/components/table/table';
import TableHeader from 'components/clarity-ui/components/table/tableHeader';
import TableRow from 'components/clarity-ui/components/table/tableRow';
import TableData from 'components/clarity-ui/components/table/tableData';

class LabelOverviewComponent extends React.Component {

  render () {
    const { id, name } = this.props;
    return (
      <Table>
        <tbody>
          <TableRow isHeader>
            <TableHeader>OVERVIEW</TableHeader>
            <TableHeader>&nbsp;</TableHeader>
          </TableRow>
          <TableRow>
            <TableData>Id:</TableData>
            <TableData>{ id }</TableData>
          </TableRow>
          <TableRow>
            <TableData>Name:</TableData>
            <TableData>{ name }</TableData>
          </TableRow>
        </tbody>
      </Table>
    );
  }
}

export default LabelOverviewComponent;



// WEBPACK FOOTER //
// ./src/components/labelViewer/details/labelOverview.component.jsx